<template>
  <div>
    <el-button
      size="mini"
      type="success"
      v-if="order.payStatus == 1 && order.applyStatus != 3"
      @click="handleOnlinePayAlert()">
      {{ btnName }}
    </el-button>
    <el-dialog title="选择支付方式" :visible.sync="payTypeDialog" width="50%" :show-close="false"
               :close-on-click-modal="false" :close-on-press-escape="false">
      <div v-loading="payDialogLoading"></div>
      <p v-if="paymentConfigs.length == 0" style="font-size: 30px">
        <span>没有可用的在线支付方式,请使用手动支付</span>
      </p>
      <p v-else>
        <el-button style="margin: 10px" v-for="(item,key) in paymentConfigs" :key="key" @click="openPayPage(item.id,order.id)"  type="success">{{ item.name }}</el-button>


      </p>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closePayPop()">关 闭</el-button>
      </div>
    </el-dialog>

    <!--dislogName：弹窗名称，可以从子页面传入，比如“新增部门”-->
    <!--dialogVisible：弹窗状态，子页面调用父页面方法的时候，进行唤醒-->
    <!--:width=big：弹窗宽度，单位百分比，子页面直接传参-->
    <el-dialog title="支付" :visible.sync="payDialogVisible" style="height: 1080px" >
      <!--:height=height：弹窗高度，单位像素，子页面直接传参-->
      <iframe :src="payUrl" width="100%" style="height: 1080px" frameborder="0" id="iframeUpdate">
      </iframe>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "payments",
  data() {
    return {
      baseUrl: window.server.baseUrl,
      paymentConfigs: [],
      payTypeDialog: false,
      payDialogLoading: false,
      token: null,
      interval:null,

      payDialogVisible:false,
      payUrl:"",
    }
  },
  props: {
    order: {
      type: Object,
      default: () => null
    },
    btnName: {
      type: String,
      default: () => "支付订单"
    },
  },
  mounted() {
    var storage = window.localStorage;
    this.token = storage["access_token"];

  },

  methods: {
    handleOnlinePayAlert() {
      this.payDialogLoading = true;
      var that = this;
      that.$api.get('/store/orders/plugins/payments', null, response => {
        if (response.status >= 200 && response.status < 300) {
          var res = response.data;
          if (res.code == 0) {
            that.payTypeDialog = true;
            that.paymentConfigs = res.data.paymentsPlugins;
            console.log(response);
            that.checkOrderPay();
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
        } else {
          this.$message({
            message: "服务器维护中",
            type: 'error'
          });
        }
        this.payDialogLoading = false;
      });
    },
    openPayPage(payment_id,order_id) {
      this.payUrl = "";
      var storage = window.localStorage;
      this.token = storage["access_token"];
      let url = this.baseUrl+'/payment/pay/'+payment_id+'?order_id='+order_id+'&access_token='+this.token;
      this.payDialogVisible = true;
      this.payUrl = url;
    },
    closePayPop() {
      if(this.interval != null) {
        clearInterval(this.interval);
        this.interval = null;
      }

      this.payTypeDialog = false;
    },
    checkOrderPay() {
      //定时检测订单是否已支付
      let that = this;
      if(this.interval == null) {
        this.interval = setInterval(function () {
            console.log("定时检测")
            that.$api.get('/store/orders/check_pay/'+that.order.id, null, response => {
              if (response.status >= 200 && response.status < 300) {
                var res = response.data;
                if (res.code == 0) {
                    if(res.data.order.payStatus == 2){
                      that.$emit('paySuccess');
                      that.closePayPop();
                    }
                }
              }
            });


        }, 3000);
      }
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/store/components/payments.vue